var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#F9FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 11.3334L12.6666 14.6667M8.66659 15.3334L12.6666 11.3334L13.9999 9.33337M7.33325 9.33337H15.3333M10.6666 7.33337H11.3333M14.6086 17.3334H19.3912M14.6086 17.3334L13.3333 20M14.6086 17.3334L16.5188 13.3394C16.6727 13.0176 16.7497 12.8566 16.855 12.8058C16.9465 12.7616 17.0533 12.7616 17.1449 12.8058C17.2502 12.8566 17.3271 13.0176 17.4811 13.3394L19.3912 17.3334M19.3912 17.3334L20.6666 20",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobLanguage);
export default __webpack_public_path__ + "static/media/job-language.372637f1f00c92c9356d753126f09e15.svg";
export { ForwardRef as ReactComponent };